import { buildClass } from "@utils/tag";
import React, { useEffect, useState } from "react";
import { components } from "react-select";
const Menu = (props) => {
  const { menuIsOpen } = props.selectProps;
  const [isOpened, setIsOpened] = useState(false);

  useEffect(() => {
    if (menuIsOpen) {
      const indecator = setTimeout(() => {
        setIsOpened(true);
      }, 0);
      return () => clearTimeout(indecator);
    } else {
      setIsOpened(false);
    }
  }, [menuIsOpen]);

  return (
    <components.Menu
      {...props}
      className={buildClass(
        "!bg-[#f8fbff] !mt-[14px] !shadow-[0px_0px_25px_10px_#0000001A]",
        "border-none !rounded-[8px] py-3 origin-top transition-all duration-300",
        { "translate-y-0 opacity-100": isOpened },
        { "translate-y-3 opacity-0": !isOpened }
      )}
    >
      {props.children}
    </components.Menu>
  );
};

export default Menu;
